<template>
  <Container class="pl-0  pt-6 w-full bg-white">
    <PageHeading :title="$t('layouts.firmware.firmware_lookup')"/>

    <ManufacturersSelectDeviceRevision :showManufacturer="false"/>
  </Container>

  <TabLayout :tabs="tabs" sticky>
    <main class="flex-1 overflow-auto">
      <router-view></router-view>
    </main>
  </TabLayout>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";
import ManufacturersSelectDeviceRevision from "@/Pages/Manufacturers/ManufacturersSelectDeviceRevision.vue";

export default {
  name: "FirmwareLayout",
  components: {ManufacturersSelectDeviceRevision, Container, PageHeading, TabLayout},
  methods: {},
  computed: {
    tabs() {
      const revision = this.$route.params.revision;

      if (!revision)
        return [];

      return [
        {
          label: this.$t('layouts.firmware.firmware'),
          to: {name: 'firmware.overview'},
          current: this.$route.name === 'firmware.overview'
        },
        // {
        //   label: this.$t('layouts.firmware.xxx'),
        //   to: {name: 'firmware.xxx'},
        //   current: this.$route.name === 'firmware.xxx'
        // }
      ].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission));
    },
  },
}
</script>

<style scoped>

</style>
